import { Component, Input, OnDestroy } from '@angular/core';
import { Firestore } from '@angular/fire/firestore';
import { MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { Data, Router } from '@angular/router';
import { AuthService } from '@core/auth.service';
import { AuthPartialRegService } from '@core/AuthServices/authPartialReg/auth-partial-reg.service';
import { LoadingService } from "@core/loading.service";
import { IonicModule } from '@ionic/angular';
import { take } from 'rxjs/operators';
import { CommonVariable } from 'src/app/app.constants';
import { PaymentService } from 'src/app/services/payment.service';

@Component({
  selector: 'app-switch-express-modal',
  templateUrl: './switch-express-modal.component.html',
  styleUrls: ['./switch-express-modal.component.scss'],
  standalone: true,
  imports: [MatDialogClose, IonicModule]
})

export class SwitchExpressModalComponent implements OnDestroy {
  @Input() currentTab: number
  userDetails: Data;
  Prosub_id: string;
  TP1: string;
  TP2: string;
  TP3: string;
  T_ID: string;
  spinnerAnimation: boolean;
  isPaymentDone: boolean;
  addingCard: boolean;
  addNewCardInProgress: boolean;
  public userId: string;

  constructor(
    private firestore: Firestore,
    private loadingService: LoadingService,
    private matDialogRef: MatDialogRef<SwitchExpressModalComponent>,
    private router: Router,
    private authService: AuthService,
    private paymentService: PaymentService,
    private AuthPartialRegService: AuthPartialRegService
  ) { }


  async ngOnInit() {
    await this.authService.getUid("SwitchExpressModalComponent").then((uid) => {
      this.userId = uid;
    })
  }

  async ngOnDestroy() {

  }

  public updateBtn(param: string): void {
    this.matDialogRef.close(param);
  }

  public goToOfferPage(): void {
    if (!this.userId) return;

    const path_id = `yzF1Ss5eiMqnh91zQMtv`;
    const doc_data = { free_reg_4h_std_mode: true };
    const method = "update";

    this.authService.getV2CloudFunction("updatefirestoredoc", {
      path_id,
      doc_data,
      method,
      merge: true,
    }).subscribe({
      next: () => {
        this.callInt2();
      },
      error: (err) => {

        return err;
      },
    });
  }

  // This function is for call interstitial 2 functionalities and redirect to specific page
  callInt2() {
    try {
      // allot the user 2 lines for successful pre-auth
      this.loadingService.present();
      this.AuthPartialRegService.assignFreebieVoucher().subscribe(() => {
        this.redirectAfterPaymentSuccess();
        this.authService.getConstantsMsg("1146").then((translatedMsg) => {
          const defaultMsg = {
            message: {
              line_1: "Congratulations!",
              line_2: "Your voucher wallet has 2 free lines",
            },
            style: {
              icon: "tick circle success.png",
              type: "Success",
            },
          };
          this.authService.showToastMessage(translatedMsg, defaultMsg);
        }).catch(error => {
          this.redirectAfterPaymentSuccess();
          this.loadingService.dismiss();
          return error;
        })
      }, (error) => {
        this.redirectAfterPaymentSuccess();
        this.loadingService.dismiss();
        return error;
      })
    } catch (error) {
      this.redirectAfterPaymentSuccess();
      this.loadingService.dismiss();
      return error;
    }
  }

  redirectAfterPaymentSuccess() {
    try {
      this.paymentService.getOptionalPage("").then(async (resp) => {
        const post_name = resp;
        if (post_name === "free-reg-complete-profile") {
          try {
            this.authService.userDetails$.pipe(take(1)).subscribe(
              (user: Data) => {
                this.userDetails = user;

                if (user?.minimal_required == true) {
                  this.paymentService.freeRegJourneyStep = "free-reg-journey-4c";
                } else {
                  //this.userProduct$.next(this.GTMservice.userProduct$.value);
                  this.paymentService.freeRegJourneyStep = "free-reg-journey-4c";
                  this.paymentService.freeRegJourneySuccessURL = post_name;
                  //this.router.navigateByUrl("successful-payment");
                  //  This is Routing Paramerts
                  const url = this.redirectionUrl(post_name);
                  this.router.navigateByUrl(url);
                }
              },
              () => {
                this.authService.getConstantsMsg("1013").then((translatedMsg) => {
                  const defaultMsg = {
                    message: {
                      line_1: "Something went wrong",
                      line_2: "",
                    },
                    style: {
                      icon: "tick circle error.svg",
                      type: CommonVariable.error,
                    },
                  };
                  this.authService.showToastMessage(translatedMsg, defaultMsg);
                });
              }
            );
          } catch (error) {
            this.authService.getConstantsMsg("1014").then((translatedMsg) => {
              const defaultMsg = {
                message: {
                  line_1: "Something went wrong",
                  line_2: "",
                },
                style: {
                  icon: "tick circle error.svg",
                  type: CommonVariable.error,
                },
              };
              this.authService.showToastMessage(translatedMsg, defaultMsg);
            });
          }
        } else {
          this.spinnerAnimation = false;
          this.isPaymentDone = false;
          this.addingCard = false;
          this.addNewCardInProgress = false;
          localStorage.setItem("4cpage", "free-reg-step-4c");
          window.location.href = `${post_name}&TP1=${this.TP1 ?? "null"}&TP2=${this.TP2 ?? "null"}&TP3=${this.TP3 ?? "null"}&T_ID=${this.T_ID ?? ""}`;
        }
        this.loadingService.dismiss();
      });
    } catch (error) {
      this.loadingService.dismiss();
      this.redirectAfterPaymentSuccess();
      return error;
    }
  }

  redirectionUrl(post_name) {
    return `${post_name +
      "?prosub_id=" +
      this.Prosub_id +
      "&" +
      "TP1=" +
      this.TP1 +
      "&" +
      "TP2=" +
      this.TP2 +
      "&" +
      "TP3=" +
      this.TP3 +
      "&" +
      "T_ID=" +
      this.T_ID
      }`
  }

}
